import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useDiscordRolesQuery = createQueryHook(MembershipsCreatorApiClient.getDiscordRoles, {
  queryKey: ['discordRoles'],
})
